export const OPTION_BUTTONS_DEFAULT_GAP = 1.5;